import { __assign, __rest } from "tslib";
/* eslint-disable no-param-reassign */
import React, { useRef } from "react";
import classNames from "classnames";
import { Image, View } from "@tarojs/components";
import { Icon } from "../icon";
import { isChildOfType } from "../_util/is-child-of-type";
import { Checkbox } from "../checkbox";
import { Radio } from "../radio";
export function ListItem(_a) {
    var title = _a.title, description = _a.description, arrow = _a.arrow, icon = _a.icon, thumb = _a.thumb, children = _a.children, before = _a.before, className = _a.className, onClick = _a.onClick, size = _a.size, props = __rest(_a, ["title", "description", "arrow", "icon", "thumb", "children", "before", "className", "onClick", "size"]);
    var ref = useRef(null);
    // children 包含 Check 时整行可点击
    if (isChildOfType(children, Checkbox) || isChildOfType(children, Radio)) {
        // eslint-disable-next-line no-param-reassign
        children = React.cloneElement(children, { ref: ref });
        // eslint-disable-next-line no-param-reassign
        onClick = function (event) {
            ref.current && ref.current.trigger(event);
        };
    }
    // before 包含 Check 时整行可点击
    if (isChildOfType(before, Checkbox) || isChildOfType(before, Radio)) {
        before = (React.createElement(View, { style: { fontSize: 0 } }, React.cloneElement(before, { ref: ref })));
        onClick = function (event) {
            ref.current && ref.current.trigger(event);
        };
    }
    if (before) {
        before = React.createElement(View, { className: "tea-item__left-icon" }, before);
    }
    if (thumb) {
        size = "auto";
        before = (React.createElement(View, { className: "tea-item__thumb--left" },
            React.createElement(View, { className: "tea-item__thumb" },
                React.createElement(Image, { className: "tea-item__thumb-image", src: thumb, mode: "scaleToFill" }))));
    }
    if (icon) {
        if (typeof icon === "string") {
            icon = { name: icon };
        }
        before = (React.createElement(Icon, __assign({}, icon, { className: classNames("tea-item__left-icon", icon.className) })));
    }
    var hasDescription = typeof description !== "undefined";
    return (React.createElement(View, __assign({ className: classNames("tea-item", "tea-hairline--bottom", {
            "is-clickable": arrow || onClick,
            "size-sm": size !== "auto" && !hasDescription,
            "size-lg": size !== "auto" && hasDescription,
            "size-auto": size === "auto",
        }), onClick: onClick }, props),
        before,
        React.createElement(View, { className: classNames("tea-item__body") },
            typeof title !== "undefined" && (React.createElement(View, { className: "tea-item__title" }, title)),
            hasDescription && (React.createElement(View, { className: "tea-item__description" }, description))),
        React.createElement(View, { className: "tea-item__value " }, children),
        arrow && (React.createElement(Icon, { className: "tea-item__detail-icon", name: "chevronright", color: "#bbbbbb" }))));
}
//# sourceMappingURL=ListItem.js.map